import axios from "axios";
import store from "@/store";

const getSubdomain = () => {
  let subdomain = window.location.host.split(".")[1]
    ? window.location.host.split(".")[0]
    : false;
  return subdomain;
};

const cliente = getSubdomain();

const httpV3 = axios.create({
  baseURL: `https://${cliente}.api.gmstg.multipex.com.br/api/pdt`,
  headers: {
    Accept: "application/json",
    "Content-Type": "applicattion/json;",
  },
});

httpV3.interceptors.request.use(
  async function (config) {
    const token = store.state.autenticacao.token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  function (erro) {
    return Promise.reject(erro);
  }
);

export default httpV3;
